// extracted by mini-css-extract-plugin
module.exports = {"activism":"activism__xjhPo"};